import {Card, CardContent, CardHeader, Chip, Divider, Grid, Stack, Typography} from "@mui/material";
import {numberFormatter} from "../../../utils/formatters/numberFormatter";
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check'
import {
    SolicitationOperationViewDetail,
    SolicitationOperationViewDetailFields
} from "../../../types/solicitation/solicitationData";
import {LabelWithData, TextSize} from "src/components/forms/LabelWithData";


interface CardGuaranteeProps {
    guarantee: SolicitationOperationViewDetail,
    accepted: boolean,
    rejected: boolean
}


const CardGuarantee = ({guarantee, accepted, rejected}: CardGuaranteeProps) => {

    const ribbonText = guarantee.agropecuarioAprobado !== null ? "Agropecuario"
        : guarantee.capitalDeTrabajoAprobado !== null ? "Capital de Trabajo"
            : guarantee.proyectoInversionAprobado !== null ? "Proyecto Inversion"
                : "Tipo no definido"
    
    return (
        <Grid item md={12}>
            <>
                {
                    
                    /*
                  
                            accepted &&
                            <Box sx={{width:'100%', justifyContent: 'center', textAlign: 'center'}}>
                                <Alert severity={'info'}>
                                    Las condiciones están sujetas al análisis financiero y que podrían verse modificadas para que sean accepteds. En los próximos dias le enviaremos más información a mail_del_solicitante@mail.com.
                                </Alert>
                            </Box>
                        }
                        {
                            rejected &&
                            <Box sx={{width:'100%', justifyContent: 'center', textAlign: 'center'}}>
                                <Alert severity={'error'}>
                                    Has rechazado la siguiente propuesta. Ten en cuenta que para pedir otra nueva se deberá realizar a través de otra solicitud.
                                </Alert>
                            </Box>
                     */
                }
            </>
            <Card sx={{
                border: '2px solid',
                borderColor: accepted ? 'green' : rejected ? 'red' : 'white',
            }}>
                <CardHeader
                    title={`Detalle de garantía`}
                    action={accepted ?
                        <Chip label='Aprobada' color='success' variant='filled' avatar={<CheckIcon fontSize={'small'} style={{ color: 'white' }} />} />
                        :
                        rejected ?
                            <Chip label='Rechazada' color='error' variant='filled' avatar={<CloseIcon fontSize={'small'} style={{ color: 'white' }}/>} />
                            :
                            <></>
                    }
                    subheader={
                    <Typography fontSize={13} color={'#00b2c9'}>
                        {`Destino: ${ribbonText}`}
                    </Typography>
                    }
                />
                <CardContent>
                    <Divider sx={{width: '100%'}} />
                    <Grid container spacing={3} pt={2}>
                        <Grid item md={4} xs={6}>
                            <Stack spacing={4}>
                                <LabelWithData label='Monto de Garantía' 
                                               value={numberFormatter.toStringWithAmount(guarantee[SolicitationOperationViewDetailFields.GuaranteeAmount], '$')}
                                               valueSize={TextSize.Medium}
                                />
                                <LabelWithData label='Porcentaje de Garantía' 
                                               value={numberFormatter.toStringWithPercentage(guarantee[SolicitationOperationViewDetailFields.GuaranteePercentage])} 
                                               valueSize={TextSize.Medium}
                                />
                                <LabelWithData label='Monto a financiar' 
                                               value={numberFormatter.toStringWithAmount(guarantee[SolicitationOperationViewDetailFields.FinanceAmount], '$')}
                                               valueSize={TextSize.Medium}
                                />
                            </Stack>
                        </Grid>
                        <Grid item md={5} xs={7}>
                            <Stack spacing={4}>
                                <LabelWithData label='Linea' 
                                               value={guarantee[SolicitationOperationViewDetailFields.LineDesc]}
                                               valueSize={TextSize.Medium}
                                />
                                <LabelWithData label='Tasa (T.N.A.)' 
                                               value={`${numberFormatter.toStringWithPercentage(guarantee[SolicitationOperationViewDetailFields.Rate])} - ${guarantee[SolicitationOperationViewDetailFields.RateMode]}`}
                                               valueSize={TextSize.Medium}
                                />
                                <LabelWithData label='Plazo' 
                                               value={`${guarantee[SolicitationOperationViewDetailFields.Term]} meses`}
                                               valueSize={TextSize.Medium}
                                />
                            </Stack>
                        </Grid>
                        <Grid item md={3} xs={5}>
                            <Stack spacing={4}>
                                <LabelWithData label='Periodicidad' 
                                               value={`${guarantee[SolicitationOperationViewDetailFields.Periodicity]}`}
                                               valueSize={TextSize.Medium}
                                />
                                <LabelWithData label='Meses de gracia' 
                                               value={`${guarantee[SolicitationOperationViewDetailFields.GracePeriod]}`}
                                               valueSize={TextSize.Medium}
                                />
                                <LabelWithData label='Sistema de amortización' 
                                               value={`${guarantee[SolicitationOperationViewDetailFields.AmortizationSystemDesc]}`}
                                               valueSize={TextSize.Medium}
                                />
                            </Stack>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Grid>
    )
}


export default CardGuarantee